// /src/pages/Blog/style.js

import { Link } from "react-router-dom";
import styled from "styled-components";

export const BlogBanner = styled.div`
    position: relative;
    width: 100%;
    height: 30vh;
    background-image: url('/placa.png');
    background-size: cover;
    background-position: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: #ffffff;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }

    h1, p {
        position: relative;
        z-index: 1;
    }

    h1 {
        font-size: 48px;
        font-weight: 700;
        margin-bottom: 10px;
    }

    p {
        font-size: 20px;
        max-width: 600px;
    }
`;

export const BlogGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 40px;
    padding: 60px 0;
`;

export const BlogCard = styled(Link)`
    text-decoration: none;
    color: inherit;
    background-color: #ede8e8ff;
    border: 3px solid #02391E;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    transition: transform 0.3s ease;

    &:hover {
        transform: translateY(-5px);
    }

    img {
        width: 100%;
        height: 200px;
        object-fit: cover;
    }
`;

export const CardContent = styled.div`
    padding: 20px;

    h3 {
        font-size: 20px;
        font-weight: 700;
        color: #02391E;
        margin: 0 0 10px 0;
    }

    p {
        font-size: 14px;
        color: #424242;
        line-height: 1.6;
    }

    span {
        display: block;
        margin-top: 15px;
        font-size: 12px;
        color: #575757;
        font-style: italic;
    }
`;